import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const purchases = [{
  name: 'Andrea F.',
  item: 'France Smart T-Shirt',
  time: '2 mins ago'
}, {
  name: 'Michael T.',
  item: 'Brazil Smart T-Shirt',
  time: '5 mins ago'
}, {
  name: 'Sarah L.',
  item: 'USA Smart T-Shirt',
  time: '12 mins ago'
}, {
  name: 'David K.',
  item: 'Argentina Smart T-Shirt',
  time: '18 mins ago'
}, {
  name: 'Emma W.',
  item: 'England Smart T-Shirt',
  time: '25 mins ago'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const runCycle = () => {
      // Show popup
      setIsVisible(true);
      // Wait 4 seconds, then hide
      timeoutId = setTimeout(() => {
        setIsVisible(false);
        // Wait 3 seconds while hidden, then move to next and repeat
        timeoutId = setTimeout(() => {
          setCurrentIndex(prev => (prev + 1) % purchases.length);
          runCycle();
        }, 3000);
      }, 4000);
    };
    // Initial delay of 10 seconds before starting the first cycle
    timeoutId = setTimeout(runCycle, 10000);
    return () => clearTimeout(timeoutId);
  }, []);
  const currentPurchase = purchases[currentIndex];
  return <div className="fixed bottom-6 left-4 sm:left-6 z-50 pointer-events-none" data-id="element-520">
      <AnimatePresence data-id="element-521">
        {isVisible && <motion.div initial={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} className="bg-brand-dark border border-white/10 rounded-2xl p-4 flex items-center gap-4 max-w-xs shadow-2xl pointer-events-auto" data-id="element-522">
            <div className="w-10 h-10 rounded-full bg-brand-cyan/20 flex items-center justify-center shrink-0" data-id="element-523">
              <ShoppingBagIcon className="w-5 h-5 text-brand-cyan" data-id="element-524" />
            </div>
            <div data-id="element-525">
              <div className="flex items-center justify-between gap-4 mb-1" data-id="element-526">
                <span className="font-bold text-sm text-white" data-id="element-527">
                  {currentPurchase.name}
                </span>
                <span className="text-xs text-gray-400" data-id="element-528">
                  {currentPurchase.time}
                </span>
              </div>
              <p className="text-xs text-gray-300 mb-1" data-id="element-529">
                {currentPurchase.item} purchased
              </p>
              <p className="text-[10px] font-bold text-brand-cyan uppercase tracking-wider" data-id="element-530">
                Selling Fast! 🔥
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}